import { SubmissionsActionTypes } from '@store/submissions'

export const clearErrors = () => ({
  type: SubmissionsActionTypes.CLEAR_ERRORS,
})
